import React, { Component } from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const HeaderContainer = styled.header`
  background: transparent;
  margin: 0 4vw;
  padding: 3vw 0;

  > a {
    display: block;
    margin: 7px 0;
    text-decoration: none;
    color: black;
    font-size: .8em;
    font-weight: bold;
    text-transform: uppercase;
    line-height: normal;
    text-shadow: 1px 1px ${props => props.theme.textShadow};
  }

  .hoverTitle {
    display: none;
  }
`;

const Logo = styled.h1`
  margin: 7px 0;
  font-size: .8em;
  text-transform: uppercase;
  a {
    // text-shadow: 1px 1px white;
    text-decoration: none;
    color: black;

  }

  :hover .title {
    display: none;
  }
  :hover .hoverTitle {
    display: block;
  }
`;

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { siteTitle } = this.props;
    return (
      <HeaderContainer>
        <Logo className="logo">
          <Link to="/" className="title">
            {siteTitle}
          </Link>
          <Link to="/" className="hoverTitle">
            FLORIAN NEBENFÃ¼HR
          </Link>
        </Logo>
        <Link to="/work/web">Work</Link>
      </HeaderContainer>
    );
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js